import { useMemo, useState, useEffect } from 'react'
import {
  Wrapper,
  Container,
  Heading,
  SelectButton,
  ButtonsContainer,
  NextButton,
} from '@components/cx-journey-content/styles'

export default function CXJourneyContent({ configData, userDetail }) {
  const [partnerSelected, setPartnerSelected] = useState('')
  const [topicSelected, setTopicSelected] = useState('')
  const [selectedLOB, setSelectedLob] = useState('')

  useEffect(() => {
    trackEvent('KMS_Panel_Loading', { email: userDetail.email })
  }, [])

  const partnersArray = useMemo(() => {
    let partnerArray = []
    if (selectedLOB) {
      if (configData.partners[selectedLOB] && configData.partners[selectedLOB].length > 0) {
        partnerArray = configData.partners[selectedLOB]
      }
    }
    return partnerArray
  }, [selectedLOB, configData])

  const topicsArray = useMemo(() => {
    let topicArray = []
    if (selectedLOB && partnerSelected) {
      if (
        configData.topics[`${selectedLOB}-${partnerSelected}`] &&
        configData.topics[`${selectedLOB}-${partnerSelected}`].length > 0
      ) {
        topicArray = configData.topics[`${selectedLOB}-${partnerSelected}`]
      }
    }
    return topicArray
  }, [selectedLOB, partnerSelected, configData])

  const handleButtonClick = (type, value) => {
    if (type === 'lob') {
      trackEvent('Tap_Panel_LOB_Name', { name: value })
      setSelectedLob(value)
      setPartnerSelected('')
      setTopicSelected('')
    }
    if (type === 'partner') {
      trackEvent('Tap_Panel_Partner_Name', { name: value })
      setPartnerSelected(value)
      setTopicSelected('')
    }
    if (type === 'topic') {
      trackEvent('Tap_Panel_Topic_Name', { name: value })
      setTopicSelected(value)
    }
  }

  const handleNextClick = e => {
    e.preventDefault()
    const encodedPartner = encodeURIComponent(partnerSelected)
    const encodedTopic = encodeURIComponent(topicSelected)
    const encodedLOB = encodeURIComponent(selectedLOB)
    const encodedURL = `/cx-kms?partner=${encodedPartner}&topic=${encodedTopic}&LOB=${encodedLOB}`
    window.location.href = encodedURL
    trackEvent('Tap_Panel_Next', {})
  }
  return (
    <Wrapper>
      <Container flexDirection="column" justifyContent="space-between">
        <div>
          <Heading style={{ marginTop: '32px', marginBottom: '8px' }}>Calling Process/Business</Heading>
          <ButtonsContainer>
            {configData.LOB.map((lob, index) => (
              <SelectButton
                selected={lob === selectedLOB}
                onClick={() => {
                  handleButtonClick('lob', lob)
                }}
                style={{
                  marginTop: '24px',
                }}
                key={index}
              >
                {lob}
              </SelectButton>
            ))}
          </ButtonsContainer>
          {selectedLOB && <Heading style={{ marginTop: '24px', marginBottom: '8px' }}>Line of Business</Heading>}
          <ButtonsContainer>
            {selectedLOB &&
              partnersArray.length > 0 &&
              partnersArray.map((partner, index) => (
                <SelectButton
                  style={{
                    marginTop: '24px',
                  }}
                  selected={partner === partnerSelected}
                  onClick={() => {
                    handleButtonClick('partner', partner)
                  }}
                  key={index}
                >
                  {partner}
                </SelectButton>
              ))}
          </ButtonsContainer>
          <div style={{ height: '20px' }}></div>
          {selectedLOB && partnerSelected && (
            <>
              <Heading style={{ marginTop: '8px', marginBottom: '8px' }}>Topics</Heading>
              <ButtonsContainer>
                {topicsArray.length > 0 &&
                  topicsArray.map((topic, index) => (
                    <SelectButton
                      style={{
                        marginTop: '24px',
                      }}
                      selected={topic === topicSelected}
                      onClick={() => handleButtonClick('topic', topic)}
                      key={index}
                    >
                      {topic}
                    </SelectButton>
                  ))}
              </ButtonsContainer>
            </>
          )}
        </div>
        <NextButton
          onClick={e => handleNextClick(e)}
          type="button"
          disabled={topicSelected.length === 0 || partnerSelected.length === 0}
        >
          Next
        </NextButton>
      </Container>
    </Wrapper>
  )
}
